import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { cancelFunctions } from 'utils/cancelFunctions';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { Store } from 'components/common/types/Store.types';
import {
  thoughtspotLiveboardStyles,
  assetHealthVisibleActions,
  TABS_STYLES,
  filterByMarket,
} from 'components/pages/Insights/LabsReportDropdown/utils';

const AssetHealth = (): React.ReactElement => {
  const { localeCode, marketId } = useSelector((state: Store) => state.publisher.configuration);

  initialiseThoughtspot(localeCode, cancelFunctions);

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={thoughtspot.assetHealthLiveboardId}
        customizations={thoughtspotLiveboardStyles}
        visibleActions={assetHealthVisibleActions}
        filterByOptions={[filterByMarket(marketId)]}
      />
    </div>
  );
};

export default AssetHealth;
